function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_newsletter_sp:customdeploy_ns_sc_ext_sl_newsletter_sp":"/app/site/hosting/scriptlet.nl?script=278&deploy=1&compid=604116&ns-at=AAEJ7tMQc58mZx0DHXLZvEkEOI4Di7o9M8QFZkAW-iMLyIy2v9g","customscript_ns_sc_ext_sl_orderstatus_of:customdeploy_ns_sc_ext_sl_orderstatus_of":"/app/site/hosting/scriptlet.nl?script=280&deploy=1&compid=604116&ns-at=AAEJ7tMQJEW6M27X1HhBBxSvG-2xpYTEUlBNWb1Lce-O2foK498","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=116&deploy=1&compid=604116&ns-at=AAEJ7tMQiUNlCzZuJOzDxO5_ApuauSe_xbm4TZUb38Dt-FiD9q0","customscript_ns_sc_sl_itembadges:customdeploy_ns_sc_sl_itembadges":"/app/site/hosting/scriptlet.nl?script=121&deploy=1&compid=604116&ns-at=AAEJ7tMQOQrshJcMRwOyQto52Ji7gbYVc2na3RlzD7sX0hGYV5A"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}